var _circle, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0F1E59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H20.8749L9 23.9244V6Z",
    fill: "url(#paint0_linear_2690_13251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.865 12.1777H20.8747L13.865 22.6603V12.1777Z",
    fill: "url(#paint1_linear_2690_13251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7934 12.1787L13.8652 16.5986V12.1787H16.7934Z",
    fill: "#0000E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2690_13251",
    x1: 12.1848,
    y1: 12.6736,
    x2: 19.5946,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F35F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2690_13251",
    x1: 15.7055,
    y1: 16.0027,
    x2: 19.8345,
    y2: 9.47307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA4073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C45"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFina);
export default __webpack_public_path__ + "static/media/fina.1b6b405d2b5aa71ef507d1a99e08a857.svg";
export { ForwardRef as ReactComponent };